import { Link, useLocation } from "react-router-dom";
import Logo from "../../assets/Logo";
import HeaderNavLink from "../../navigation/HeaderNavLink";
import SpyGlass from "../../icons/SpyGlass/index.js";
import BlueButton from "../../buttons/BlueButton/index.js";
import ArrowUpRight from "../../icons/ArrowUpRight/index.js";
import TextInput from "../../assets/inputs/TextInput";
import { useEffect, useState } from "react";
import clsx from "clsx";
import MosaicsLine from "../MosaicsLine/index.js";
import { useMediaQuery } from "react-responsive";
import axios from "axios";
import { BASE_URL, decodeHtmlEntities, stripHtmlTags } from "../../../globals.js";

function SearchForm({
    onReset = () => { }
}) {
    const [searchValue, setSearchValue] = useState("");
    const [results, setResults] = useState([]);

    function resetValue() {
        setSearchValue("");
        onReset();
    }

    async function fetchResults() {
        const post_type = "realisation";
        try {
            const response = await axios.get(`${BASE_URL}/${post_type}?search=${searchValue}&per_page=3`);
            const data = [...response.data].map((post) => {
                return {
                    id: post.id,
                    slug: post.slug,
                    title: decodeHtmlEntities(post.title.rendered),
                    excerpt: decodeHtmlEntities(stripHtmlTags(post.excerpt ? post.excerpt.rendered : "")),
                    featured_media: post.featured_media
                }
            });
            for (let post of data) {
                const mediaData = await axios.get(`${BASE_URL}/media/${post.featured_media}`);
                post.thumbnail = mediaData.data.source_url
            }
            setResults(data);
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        if(searchValue!==""){
            fetchResults();
        } else {
            setResults([]);
        }
    }, [searchValue]);

    return (
        <>
            <form className="bg-zoeil-grey min-w-[500px] tablet:min-w-[400px] mobile:min-w-full flex items-center px-[1.875rem] relative z-[60]" onSubmit={(e) => {
                e.preventDefault();
            }}>
                <TextInput
                    type="text"
                    placeholder="Rechercher..."
                    className="!bg-transparent w-full mobile:!p-[1.25rem] mobile:!text-heading-6 mobile:min-w-full"
                    value={searchValue}
                    changeHandler={setSearchValue} />
                <button className="w-[24px] aspect-square block" onClick={resetValue}>
                    <div className="w-full h-full relative after:content-[''] after:absolute after:w-full after:h-[2px] after:bg-[rgba(0,0,0,0.6)] after:top-1/2 after:left-1/2 after:-translate-x-1/2 after:-translate-y-1/2 after:rotate-45 before:content-[''] before:w-full before:h-[2px] before:bg-[rgba(0,0,0,0.6)] before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:-rotate-45">
                    </div>
                </button>
            </form>
            {results.length > 0 &&
                <div className="absolute w-dvw h-dvh bg-white top-full left-0 pt-8 z-50 mobile:top-0 mobile:h-full mobile:pt-80">
                    <div className="max-w-[1300px] mx-auto px-6 max-h-full overflow-scroll" style={
                        {
                            overflowX: "clip"
                        }
                    }>
                        <h2 className="text-heading-4 font-bold mobile:text-very-large">
                            Résultats pour : <span className="text-zoeil-blue">{searchValue}</span>
                        </h2>
                        <ul className="flex flex-col mt-8">
                            {results.map(result =>
                                <li className="transition-all hover:bg-zoeil-grey">
                                    <Link to={`/realisations/${result.slug}`}>
                                        <div className="flex items-center gap-[2rem] p-[1.25rem] mobile:flex-col">
                                            <img src={result.thumbnail} alt={result.title} className="max-w-[200px] aspect-[4/3] object-cover mobile:max-w-none mobile:w-full mobile:h-[150px]" />
                                            <div className="flex flex-col gap-[1.5rem] mobile:w-full">
                                                <h3 className="text-heading-6 font-bold leading-[100%]">
                                                    {result.title}
                                                </h3>
                                                <p>
                                                    {result.excerpt}
                                                </p>
                                            </div>
                                        </div>
                                    </Link>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>}
        </>
    )
}

export default function Header() {
    const [isSearching, setIsSearching] = useState(false);
    const [isBurgerActive, setIsBurgerActive] = useState(false);
    const isMobile = useMediaQuery(
        {
            query: '(max-width: 780px)'
        }
    )
    const location = useLocation();

    useEffect(() => {
        setIsBurgerActive(false);
    }, [location])
    return (
        <header className="fixed top-0 left-0 w-full flex justify-center items-center py-[1rem] bg-white z-[999] px-6">
            <nav className="max-w-[1658px] flex justify-between items-center w-full">
                <Link to={"/"} className="text-zoeil-blue w-[8rem] tablet:w-[8rem] relative z-50">
                    <Logo />
                </Link>
                <div className={clsx(
                    "flex items-center gap-[6.25rem] small-computer:gap-[2rem]",
                )}>
                    {(isSearching && !isMobile) ?
                        <SearchForm onReset={() => {
                            setIsSearching(false);
                        }} />
                        :
                        <div className={clsx(
                            "mobile:absolute flex items-center gap-[1rem] tablet:gap-0 mobile:fixed mobile:left-0 mobile:w-dvw mobile:bg-white mobile:flex-col mobile:items-start mobile:px-[3.27rem] mobile:w-full mobile:pt-48 mobile:pb-36 transition-all duration-500 mobile:min-h-dvh mobile:top-0",
                            isBurgerActive ? "mobile:translate-y-0" : "mobile:-translate-y-full"
                        )}>
                            <div className="hidden mobile:block w-full mb-[1.8rem]">
                                <SearchForm />
                            </div>
                            <HeaderNavLink className={"hidden mobile:block"} to={"/"}>
                                Accueil
                            </HeaderNavLink>
                            <HeaderNavLink to={"/services"}>
                                Nos Services
                            </HeaderNavLink>
                            <HeaderNavLink to={"/realisations"}>
                                Nos Réalisations
                            </HeaderNavLink>
                            <HeaderNavLink to={"/about"}>
                                Zoeil ?
                            </HeaderNavLink>
                            <div className="hidden mobile:block w-full mt-[1.8rem]">
                                <Link to={"/contact"}>
                                    <BlueButton icon={<ArrowUpRight />}>
                                        Demander un Call
                                    </BlueButton>
                                </Link>
                            </div>
                            <div className="absolute bottom-0 left-0 w-full hidden mobile:block">
                                <MosaicsLine number={9} />
                            </div>

                        </div>}
                    {!isSearching && <button className="w-[2.25rem] aspect-square transition-all hover:opacity-50 mobile:hidden" onClick={() => {
                        setIsSearching(!isSearching);
                    }}>
                        <SpyGlass />
                    </button>}
                </div>
                <Link className="mobile:hidden" to={"/contact"}>
                    <BlueButton icon={<ArrowUpRight />}>
                        Demander un Call
                    </BlueButton>
                </Link>
                <button className="hidden mobile:block w-[34px] aspect-square relative z-50 overflow-visible" onClick={() => {
                    setIsBurgerActive(!isBurgerActive);
                }}>
                    <div className={clsx(
                        "w-full absolute top-1/2 left-0 transition-all -translate-y-1/2 bg-black h-[4px] after:content-[''] after:w-full after:h-full after:left-0 after:top-0 after:bg-black after:absolute after:-translate-y-[11px] before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-black before:translate-y-[11px] after:transition-all before:transition-all after:origin-center before:origin-center",
                        isBurgerActive && "before:!translate-y-0 after:!translate-y-0 before:rotate-45 after:-rotate-45 bg-transparent"
                    )}></div>
                </button>
            </nav>
        </header>
    )
}